<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Product Demand Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        title: 'Product Demand Report Today'
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Product Demand Report Today",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Product Demand Report Today",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount:0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product_name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product_name",
        QUANTITY: "quantity",
        AMOUNT: "amount",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("products", ["ProductDemand"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductDemand ? this.ProductDemand.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductDemand ? this.ProductDemand.length : 1;
  },
  methods: {
    ...mapActions({
      FetchProductDemand: "products/fetchProductdemand",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    ProductDemandData(){      
      this.data.title = "Product Demand Report From "+
            this.data.datefrom +
            " To " +
            this.data.dateto;
      this.FetchProductDemand(this.data);
    },
  },
  created() {
    this.FetchProductDemand(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-primary"
                  :data="ProductDemand"
                  :fields="json_fields"
                  :worksheet="'PRODUCT DEMAND REPORT ON' + currentdate"
                  type="csv"
                  :name="'Product_demand' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="ProductDemandData()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="ProductDemandData()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ProductDemand?ProductDemand:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ thousandSeperator(data.item.amount) }}
                </template>
              </b-table>
            </div>
            <Loader  v-if="!ProductDemand"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
